import { GradeBadge } from "@l2r-front/l2r-common"
import { styled } from "@l2r-front/l2r-ui"

export const ChildrenGradeBadge = styled(GradeBadge)({
    display: "flex",
    height: "24px",
})